import React from 'react';
import { AgentRun } from './AgentChat.types';

const VISIBLE_LIMIT = 5;

const formatWhen = (iso: string): string => {
  const date = new Date(iso);
  const sameDay = new Date().toDateString() === date.toDateString();
  try {
    return sameDay
      ? date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
      : date.toLocaleDateString([], { month: 'short', day: 'numeric' });
  } catch {
    return date.toDateString();
  }
};

export const AgentChatHistory: React.FC<{
  runs: AgentRun[];
  activeRunId: string | null;
  onOpen: (runId: string) => void;
}> = ({ runs, activeRunId, onOpen }) => {
  const visible = runs.slice(0, VISIBLE_LIMIT);

  return (
    <div className="agent-history">
      <div className="agent-history-label">Recent Chats</div>
      {visible.map((run) => (
        <button
          key={run.id}
          type="button"
          className={`agent-history-row${
            run.id === activeRunId ? ' is-active' : ''
          }`}
          onClick={() => onOpen(run.id)}
        >
          <span className="agent-history-title">{run.prompt}</span>
          <span className="agent-history-meta">
            <span className="agent-history-time">
              {formatWhen(run.createdAt)}
            </span>
          </span>
        </button>
      ))}
    </div>
  );
};

export default AgentChatHistory;
